import { useCustom } from "@refinedev/core";
import { AccountType } from "../../../models/account";

type QontoConnectionStatus = {
  connected?: boolean;
};

export function isAccountSyncedWithQonto(
  account?: {
    qontoClientId?: string | null;
    qontoSyncError?: boolean;
  } | null,
): boolean {
  return Boolean(account?.qontoClientId || account?.qontoSyncError);
}

export function useRequiresQontoInternationalPhone(
  account?: {
    qontoClientId?: string | null;
    qontoSyncError?: boolean;
  } | null,
  accountType?: AccountType,
): boolean {
  const { data: statusResponse } = useCustom<QontoConnectionStatus>({
    url: "integrations/qonto",
    method: "get",
    queryOptions: {
      retry: false,
      staleTime: 60_000,
    },
  });

  if (isAccountSyncedWithQonto(account)) {
    return true;
  }

  const isQontoConnected = statusResponse?.data?.connected === true;
  return isQontoConnected && accountType !== undefined;
}
